<script>
  import { t } from '../../i18n/index.js';
  import { StabilityState } from '../../stability-tracker.js';

  let { state = StabilityState.NOT_DETECTED } = $props();

  let statusClass = $derived(
    state === StabilityState.NOT_DETECTED ? 'detecting' :
    state === StabilityState.UNSTABLE ? 'unstable' :
    state === StabilityState.STABILIZING ? 'stabilizing' :
    'stable'
  );

  let statusText = $derived(
    state === StabilityState.NOT_DETECTED ? t('detect.searching') :
    state === StabilityState.UNSTABLE ? t('detect.unstable') :
    state === StabilityState.STABILIZING ? t('detect.stabilizing') :
    t('detect.capturing')
  );
</script>

<div class="realtime-status {statusClass}">
  <span class="realtime-status-dot"></span>
  <span class="realtime-status-text">{statusText}</span>
</div>

<style>
  .realtime-status {
    position: absolute;
    top: 56px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 20;
    background: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(8px);
    padding: 10px 20px;
    border-radius: 999px;
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 0.9375rem;
    font-weight: 500;
    transition: all 0.3s ease;
  }

  .realtime-status-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    transition: background-color 0.3s ease;
  }

  .realtime-status.detecting .realtime-status-dot {
    background: #ef4444;
  }

  .realtime-status.unstable .realtime-status-dot {
    background: #eab308;
  }

  .realtime-status.stabilizing .realtime-status-dot {
    background: #22c55e;
    animation: pulse-dot 0.8s ease-in-out infinite;
  }

  .realtime-status.stable .realtime-status-dot {
    background: #22c55e;
  }

  @keyframes pulse-dot {
    0%, 100% { transform: scale(1); opacity: 1; }
    50% { transform: scale(1.3); opacity: 0.7; }
  }

  .realtime-status-text {
    color: white;
  }
</style>
